import apiClient from "./apiClient";
import { API_BASE_URL, API_ENDPOINTS } from "../config/config";

/**
 * The Orbit User Guide: a web page the backend renders from docs/user-guide/ORBIT_USER_GUIDE.md
 * (orbit-connectors) and keeps off the public internet. "User Guide" in the left menu opens Orbit's own
 * /user-guide page (UserGuidePage) in a new tab, so the address bar shows Orbit's address. That page shows the
 * backend's guide page in a frame, at a guide-only link from POST /api/v1/user-guide/link (valid about 12 hours).
 */

/**
 * A guide-only link for the signed-in user. The backend lets only the Orbit address that asks for it (the
 * browser sends it as the request's Origin) show the guide in a frame, and names that address as frame_origin.
 * @returns {Promise<{url: string, version: string|null, frameOrigin: string|null}>} the guide page's full
 *   address, the guide's release, and the address allowed to frame it (null: none)
 */
export async function getUserGuideLink() {
  const { data } = await apiClient.post(API_ENDPOINTS.USER_GUIDE_LINK);
  const path = String(data?.path || "");
  if (!path.startsWith("/")) {
    throw new Error("The user guide link isn't a path on the API");
  }
  return {
    url: `${String(API_BASE_URL).replace(/\/$/, "")}${path}`,
    version: data.version || null,
    frameOrigin: data.frame_origin || null
  };
}

/**
 * Show the guide in this tab, at the API's own address: for an API that won't let this page frame it
 * (one from before it could).
 */
export function openUserGuideHere(url) {
  window.location.replace(url);
}
